import styles from "./index.module.less";
import { ButtonField, Iconsvg, Pagination } from "@wk/components-react16";
import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import banner5 from "@/assets/img/banner5.png";
import unKnownJudges from "@/assets/img/unKnownJudges.png";
import { useUser } from "@/utils/UserContext";
import { findValueByIdAndKey } from "@/utils";
import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
  // getCaseList,
  getFinalCaseList,
} from "@/services/history";
const Judge = () => {
  const navigate = useNavigate();
  const { judge } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);
  const [yyList, setYyList] = useState([]);
  const [alList, setAlList] = useState([]);

  const [historyList, setHistoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const zcText = useMemo(() => {
    return (
      findValueByIdAndKey(zcList, userInfo?.experience, "itemText") || "--"
    );
  }, [zcList, userInfo]);

  const yyText = useMemo(() => {
    return (
      findValueByIdAndKey(yyList, userInfo?.institution, "itemText") || "--"
    );
  }, [yyList, userInfo]);

  const ksText = useMemo(() => {
    const value = userInfo?.dept;
    if (!value) return "--";

    return value
      .split(",")
      .map((item) => findValueByIdAndKey(ksList, item, "title", "key"))
      .join("、");
  }, [ksList, userInfo]);

  const alText = useCallback(
    (detail) => {
      if (!detail) return "-";
      return (
        findValueByIdAndKey(alList, detail?.caseType, "itemText", "id") ||
        detail?.anliType ||
        "-"
      );
    },
    [alList]
  );

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const getYyList = async () => {
    const zcList = await getCaseTypeDict("yy");
    setYyList(zcList);
  };

  const getAlList = async () => {
    const zcList = await getCaseTypeDict("al");
    setAlList(zcList);
  };

  // 点击下一页
  const onNextArrowClick = () => {
    setCurrentPage((prev) => prev + 1);
    scrollToHistoryList();
  };

  // 点击上一页
  const onPreviousClick = () => {
    setCurrentPage((prev) => prev - 1);
    scrollToHistoryList();
  };

  // 点击页码
  const onPageClick = (event) => {
    setCurrentPage(event);
    scrollToHistoryList();
  };

  const scrollToHistoryList = () => {
    const historyListElement = document.querySelector(".list-title");
    if (historyListElement) {
      historyListElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getCaseLists = async (params) => {
    const res = await getFinalCaseList(params);
    if (res.code === 200) {
      setHistoryList(res.result.records);
      setTotal(res.result.total);
    }
  };

  const getList = useCallback(() => {
    if (!userInfo?.id) return;
    const params = {
      pageNo: currentPage,
      pageSize: 10,
      // px: "2",
      judgeId: userInfo.id,
      // belongYear: "2025",
    };
    getCaseLists(params);
  }, [userInfo, currentPage]);

  useEffect(() => {
    setUserInfo(judge || {});
  }, [judge]);

  useEffect(() => {
    getList();
  }, [userInfo, currentPage]);

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
    getYyList();
    getAlList();
  }, []);

  return (
    <div className={styles["judges-homepage-box"]}>
      <img src={banner5} alt="" className="img-fluid" />
      <div className="content-box">
        <div className="header-box">
          <div className="left-header-box">我的主页</div>
          <div
            className="right-header-box"
            onClick={() => {
              navigate("/judgesHomepage/detail");
            }}
          >
            修改个人信息
          </div>
        </div>

        <div className="info-box">
          <img
            src={userInfo?.pic || unKnownJudges}
            alt=""
            className="header-img"
          />
          <div className="info-right-box">
            <div className="name-box">{userInfo?.userName || "-"}</div>
            <div className="industry-box">
              <div>{`${yyText}${ksText}`}</div>
              <div>{zcText}</div>
            </div>
            <div className="description-box">
              {userInfo?.introduction || "-"}
            </div>
            {/* <div className="data-box">评审截止日期：2025年11月3日 0:00</div> */}
          </div>
        </div>

        <div className="list-box">
          <div className="list-title">案例</div>
          <div className="list-content">
            {historyList.map((item) => {
              return (
                <div className="item-box" key={item.id}>
                  <img
                    src={
                      item?.activityParticipateInfo?.imgUrl
                        ? item?.activityParticipateInfo?.imgUrl.split(",")[0]
                        : ""
                    }
                    alt=""
                    className="history-list-item-img"
                  />

                  <div className="item-left">
                    <div className="history-list-item-info">
                      <div className="item-title">
                        {item?.activityParticipateInfo?.name}
                      </div>
                      <div className="item-desc">
                        {item?.activityParticipateInfo?.description}
                      </div>
                      <div className="item-date">
                        <div className="item-number">
                          案例编号: {item?.activityParticipateInfo?.number}
                        </div>
                        <div className="item-type">
                          案例类型: {alText(item?.activityParticipateInfo)}
                        </div>
                        <div className="item-status">
                          评审状态:
                          <span
                            className={
                              item?.score || item?.score === 0
                                ? "status-submitted"
                                : "status-unsubmitted"
                            }
                          >
                            {item?.score || item?.score === 0
                              ? "已评审"
                              : "未评审"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="history-list-item-btn">
                      <ButtonField iconPosition={"right"} mode={"ghost"}>
                        <button
                          type="button"
                          onClick={() => {
                            if (item?.score || item?.score === 0) {
                              navigate(
                                `/externalRating/result?judgeId=${item?.judgeId}&tbScoreId=${item?.id}`
                              );
                            } else {
                              navigate(
                                `/externalRating?id=${item?.activityParticipateInfo?.id}`
                              );
                            }
                          }}
                        >
                          {item?.score || item?.score === 0
                            ? "查看评审结果"
                            : "评审"}
                          <Iconsvg name="arrow-right"></Iconsvg>
                        </button>
                      </ButtonField>
                    </div>
                  </div>
                </div>
              );
            })}

            {historyList.length === 0 && (
              <div className="no-data">无搜索结果</div>
            )}

            <div className="pagination-box">
              {total > 0 && (
                <Pagination
                  pageIndex={currentPage}
                  controlMode={"controlled"}
                  pageCount={Math.ceil(total / 10)}
                  onOnNextArrowClick={onNextArrowClick}
                  onOnPreviousArrowClick={onPreviousClick}
                  onOnPageClick={(event) => onPageClick(event)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Judge;
